import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import Colors from '../../../constants/Colors';
import PageSkeleton from '../../../components/PageSkeleton';
import PriceClassifierChart from './PriceClassifierChart';
import { usePriceClassifierData } from '../../../utils/api-hooks/analytics';

const PriceClassifierContainer = ({ apiParams, ...rest }) => {
  const { t } = useTranslation();
  const { email, commodity } = apiParams || {};

  const { data, isLoading, isError, error } = usePriceClassifierData(email, commodity);

  if (isLoading) {
    return <PageSkeleton shape="chart" />;
  }

  if (isError) {
    return (
      <div className="h-full w-full flex flex-col items-center justify-center gap-3 px-4">
        <AlertCircle
          size={32}
          style={{ color: Colors.error || '#ef4444' }}
        />
        <p className="text-gray-400 text-sm text-center">
          {error?.message || t('charts.errorLoading')}
        </p>
      </div>
    );
  }

  return (
    <PriceClassifierChart
      data={data || []}
      email={email}
      commodity={commodity}
      {...rest}
    />
  );
};

export default PriceClassifierContainer;
